import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import { useBefehlForm } from '../../../hooks'
import { Befehl5 } from '../../../models'
import { AuftragX_95Form } from '../Auftraege'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import {
  convertBefehl5FormDataToModel,
  convertModelToBefehl5FormData
} from './converters'
import { Befehl5FormData, createBefehl5FormValidationSchema } from './schema'
import Auftrag5_41Form from './Auftrag5_41Form'

/**
 * Main form component for Befehl 5
 */
export default function Befehl5Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-5-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl5>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl5FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl5FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl5FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl5FormData) => {
      const updatedBefehl = convertBefehl5FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl5FormData>
      befehlKennung="5"
      title={t('befehle.5.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 5.41 */}
      <Auftrag5_41Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-5-41`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      {/* Auftrag 5.95 */}
      <AuftragX_95Form
        befehlKennung="5"
        fieldNamePrefix="auftrag_5_95"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-5-95`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        withGrundTabelle
      />
    </BefehlFormWrapper>
  )
}
